import loginClient from '../../client/loginClient';
export default class Model {
    public resultData = null;
    public ajaxLoginData = null;

    public async getData(params: any) {
        const result = await loginClient.getData(params);
        if (result && result.success) {
            this.resultData = result;
        }
    }
    public async ajaxLogin(params: any) {
        const result = await loginClient.ajaxLogin(params);
        if (result && result.success) {
            this.ajaxLoginData = result;
        }
    }
    public async add(params: any) {
        const result = await loginClient.add(params);
        if (result) {
            return result;
        }
    }
    public async editPassword(params: any) {
        const result = await loginClient.editPassword(params);
        if (result) {
            return result;
        }
    }
    
}
